// Ordering for the "Radio Environment" table on the device detail page.
//
// A scan entry's `rssi` is optional: the macOS client omits it when the scan
// value is not a real measurement (see `WiFiRSSI.validated` in the macOS
// client). An omitted or null `rssi` means "unknown", which is not the same
// as "weak", so it must never be compared as if it were a number.

import type { z } from 'zod'
import type { NetworkSnapshotWiFiScanSchema } from '../api/schemas'

export type WiFiScan = z.infer<typeof NetworkSnapshotWiFiScanSchema>

/**
 * Returns a copy of `scans` sorted strongest signal first, with every entry
 * whose `rssi` is missing placed after all measured entries. The sort is
 * stable, so entries with no `rssi` keep their original relative order.
 */
export function sortWifiScansBySignal<T extends Pick<WiFiScan, 'rssi'>>(scans: readonly T[]): T[] {
  return [...scans].sort((a, b) => {
    if (a.rssi == null) return b.rssi == null ? 0 : 1
    if (b.rssi == null) return -1
    return b.rssi - a.rssi
  })
}
